import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-dots',
  standalone: true,
  templateUrl: './loading-dots.component.html',
  styleUrls: ['./loading-dots.component.css'],
})
export class LoadingDotsComponent {
  @Input() color: string = 'bg-white';
}
